// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EsignVerify_container__f7wnN {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background-color: #f5f5f5;
    padding: 20px;
}

.EsignVerify_card__CYBit {
    background: white;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    text-align: center;
    max-width: 400px;
    width: 100%;
    transition: all 0.3s ease;
}

.EsignVerify_card__CYBit:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.EsignVerify_title__DRMlR {
    font-family: 'CircularXXWeb-Medium', sans-serif;
    font-size: 24px;
    color: #333;
    margin: 0 0 15px 0;
}

.EsignVerify_message__wxOUl {
    font-family: 'CircularXXWeb-Medium', sans-serif;
    font-size: 16px;
    color: #404040BF;
    margin: 0 0 25px 0;
    line-height: 1.5;
}

.EsignVerify_loader__ovGT1 {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #f73439;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: EsignVerify_spin__T4hoa 1s linear infinite;
    margin: 20px auto;
}

@keyframes EsignVerify_spin__T4hoa {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.EsignVerify_icon__Kn5Fx {
    width: 60px;
    height: 60px;
    margin-bottom: 20px;
}

.EsignVerify_retryButton__nONac {
    background-image: linear-gradient(45deg, #f73439, #f8777b);
    font-family: 'CircularXXWeb-Medium', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    border-radius: 12px;
    border: none;
    cursor: pointer;
    padding: 12px 30px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(247, 52, 57, 0.2);
    width: 100%;
    max-width: 300px;
}

.EsignVerify_retryButton__nONac:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(247, 52, 57, 0.3);
    background-image: linear-gradient(45deg, #f8777b, #f73439);
}

.EsignVerify_retryButton__nONac:active {
    transform: translateY(0);
    box-shadow: 0 2px 10px rgba(247, 52, 57, 0.2);
}

@media screen and (max-width: 768px) {
    .EsignVerify_card__CYBit {
        padding: 20px;
    }
    
    .EsignVerify_title__DRMlR {
        font-size: 20px;
    }
    
    .EsignVerify_message__wxOUl {
        font-size: 14px;
    }
}

@media screen and (max-width: 480px) {
    .EsignVerify_container__f7wnN {
        padding: 10px;
    }
    
    .EsignVerify_card__CYBit {
        padding: 15px;
    }
    
    .EsignVerify_title__DRMlR {
        font-size: 18px;
    }
    
    .EsignVerify_icon__Kn5Fx {
        width: 40px;
        height: 40px;
    }
    
    .EsignVerify_loader__ovGT1 {
        width: 32px;
        height: 32px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/organism/EsignVerify.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qDAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,0DAA0D;IAC1D,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,6CAA6C;IAC7C,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;IAC7C,0DAA0D;AAC9D;;AAEA;IACI,wBAAwB;IACxB,6CAA6C;AACjD;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 100vh;\n    background-color: #f5f5f5;\n    padding: 20px;\n}\n\n.card {\n    background: white;\n    border-radius: 12px;\n    padding: 30px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    text-align: center;\n    max-width: 400px;\n    width: 100%;\n    transition: all 0.3s ease;\n}\n\n.card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n}\n\n.title {\n    font-family: 'CircularXXWeb-Medium', sans-serif;\n    font-size: 24px;\n    color: #333;\n    margin: 0 0 15px 0;\n}\n\n.message {\n    font-family: 'CircularXXWeb-Medium', sans-serif;\n    font-size: 16px;\n    color: #404040BF;\n    margin: 0 0 25px 0;\n    line-height: 1.5;\n}\n\n.loader {\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid #f73439;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 1s linear infinite;\n    margin: 20px auto;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.icon {\n    width: 60px;\n    height: 60px;\n    margin-bottom: 20px;\n}\n\n.retryButton {\n    background-image: linear-gradient(45deg, #f73439, #f8777b);\n    font-family: 'CircularXXWeb-Medium', sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    color: #fff;\n    border-radius: 12px;\n    border: none;\n    cursor: pointer;\n    padding: 12px 30px;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 15px rgba(247, 52, 57, 0.2);\n    width: 100%;\n    max-width: 300px;\n}\n\n.retryButton:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(247, 52, 57, 0.3);\n    background-image: linear-gradient(45deg, #f8777b, #f73439);\n}\n\n.retryButton:active {\n    transform: translateY(0);\n    box-shadow: 0 2px 10px rgba(247, 52, 57, 0.2);\n}\n\n@media screen and (max-width: 768px) {\n    .card {\n        padding: 20px;\n    }\n    \n    .title {\n        font-size: 20px;\n    }\n    \n    .message {\n        font-size: 14px;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .container {\n        padding: 10px;\n    }\n    \n    .card {\n        padding: 15px;\n    }\n    \n    .title {\n        font-size: 18px;\n    }\n    \n    .icon {\n        width: 40px;\n        height: 40px;\n    }\n    \n    .loader {\n        width: 32px;\n        height: 32px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EsignVerify_container__f7wnN`,
	"card": `EsignVerify_card__CYBit`,
	"title": `EsignVerify_title__DRMlR`,
	"message": `EsignVerify_message__wxOUl`,
	"loader": `EsignVerify_loader__ovGT1`,
	"spin": `EsignVerify_spin__T4hoa`,
	"icon": `EsignVerify_icon__Kn5Fx`,
	"retryButton": `EsignVerify_retryButton__nONac`
};
export default ___CSS_LOADER_EXPORT___;
